import * as React from 'react'
import { Map } from 'react-loadable'

export const prefetch = () =>
  import('./UsersPage')

export const UsersPage = Map({
  loader: {
    Module: prefetch
  },
  loading: () => null,
  render: ({ Module }, props) => <Module.default {...props} />
})



// WEBPACK FOOTER //
// ./src/routes/UsersPage/index.js